"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var react_1 = require("swiper/react");
var modules_1 = require("swiper/modules");
var hooks_1 = require("preact/hooks");
var cinematic_cross_sell_1 = require("../../utils/shopify-graphql/cinematic-cross-sell");
var path_1 = require("../../utils/shopify/path");
var media_query_1 = require("../../hooks/media-query");
var CinematicCrossSell = function () {
    var _a = (0, hooks_1.useState)(null), cinematicCrossSellData = _a[0], setCinematicCrossSellData = _a[1];
    var isDesktop = (0, media_query_1.useMediaQuery)('(min-width: 1025px)');
    (0, hooks_1.useEffect)(function () {
        var url = window.location;
        var handle = url.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, cinematic_cross_sell_1.getCinematicCarouselData)(handle, pathType)
            .then(function (data) {
            if (data) {
                setCinematicCrossSellData(data);
            }
        })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (cinematicCrossSellData) {
        return ((0, preact_1.h)(react_1.Swiper, { autoplay: { pauseOnMouseEnter: true }, loop: true, modules: [modules_1.Autoplay, modules_1.Navigation], navigation: true }, cinematicCrossSellData.map(function (data) {
            var imageUrl = isDesktop ? data.desktopImageUrl : data.mobileImageUrl;
            var _a = data.description.split('|'), description1 = _a[0], description2 = _a[1];
            return ((0, preact_1.h)(react_1.SwiperSlide, { class: "cinematic-cross-sell-v2__container", key: data.description },
                (0, preact_1.h)("img", { class: "cinematic-cross-sell-v2__image", src: imageUrl, loading: window.isLazyVPTest ? 'lazy' : 'eager' }),
                (0, preact_1.h)("div", { class: "cinematic-cross-sell-v2__info" },
                    (0, preact_1.h)("img", { class: "cinematic-cross-sell-v2__logo", src: data.logo, loading: window.isLazyVPTest ? 'lazy' : 'eager' }),
                    (0, preact_1.h)("p", { class: "cinematic-cross-sell-v2__description" },
                        description1,
                        " ",
                        (0, preact_1.h)("br", { class: "hide-on-desktop" }),
                        description2)),
                (0, preact_1.h)("a", { href: data.collectionUrl },
                    (0, preact_1.h)("button", { class: "cinematic-cross-sell-v2__cta cinematic-cross-sell-v2__cta--".concat(data.theme) }, "Shop Now"))));
        })));
    }
    return (0, preact_1.h)(preact_1.Fragment, null);
};
exports.default = CinematicCrossSell;
